import { Container, DownloadIcon } from "./style";

export default function PdfButtons() {
  return (
    <Container>
      <DownloadIcon onClick={() => window.print()} title="Baixar" />
    </Container>
  );
}
